import 'whatwg-fetch';
import { SERVICES } from '../constants/global';

export const fetch = window.fetch;

/**
 *
 * @param endpoint
 * @param options
 */
export const authFetch = async (endpoint: string, options?: any) => {
    let response, data;
    try {
        const url = `${SERVICES}${endpoint}`;
        response = await fetch(url, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'manual',
            ...options,
        });
    } catch (error) {
        throw new Error('UNKNOWN');
    }

    if (response.ok) {
        try {
            data = await response.json();
            return { data };
        } catch (error) {
            // valid response but empty body just return {}
            return {};
        }
    } else {
        try {
            data = await response.json();
        } catch (error) {
            throw new Error('UNKNOWN');
        }
        if (data.errorCode && data.errorMessage) {
            throw new Error(data.errorCode);
        }
        throw new Error('UNKNOWN');
    }
};

export default {
    authFetch,
};
